<template>
  <div class="transaction-overview">
    <img class="transaction-overview__logo" src="@/assets/images/header/logo.png"/>
    <div v-if="!isWin" class="transaction-overview__title">
      You have not won, Don't give up, Try again!
    </div>
    <div v-if="isWin" class="transaction-overview__title">
      You have Won!
    </div>
    <TableOverview
      :title="'Transaction(s) Overview'"
      :isPagination="false"
      :customFoot="true"
      :footFields="footFields"
      :fields="fields"
      :items="transactions"
      :is-pos-device="true"
      :custom-title="'transaction-overview-title'"
    />
    <div class="transaction-overview__submit">
      <b-button class="btn-ticket btn-back-home" @click="handleBackHome">Back Home</b-button>
      <b-button v-if="isWin && !paidOut" class="btn-payout" @click="handlePayout">Payout</b-button>
      <b-button v-if="isWin && paidOut" class="btn-payout" @click="handlePayout">Paid Out</b-button>
    </div>
  </div>
</template>
<script>
import TableOverview from '@/components/common/table/table';
import lottoService from '@/services/lotto.service';
import accountService from '@/services/account.service';
export default {
  components: {
    TableOverview
  },
  data() {
    return {
      ref: null,
      isWin: false,
      paidOut: false,
      totalWinnings: 0,
      transactions: [],
      fields: [
        {key: 'id', label: 'Bet ID'},
        {key: 'date', label: 'Date Created'},
        {key: 'type', label: 'Type'},
        {key: 'mainNumbers', label: 'Numbers'},
        // {key: 'wager', label: 'Amount'},
        {key: 'winnings', label: 'Winnings'}
      ],
      footFields: [
        {value: '', label: 'Total amount due'}
      ]
    }
  },
  computed: {
    rows() {
      return this.total
    }
  },
  created() {

    this.ref = this.$route.query.ref;
    lottoService.scanTicket(this.ref).then((res) => {
      if (res.status === 'success') {

        const transactions = res.data.transactions;
        console.log('??', transactions);
        this.isWin = res.data.isWin;
        this.totalWinnings = res.data.totalWinnings;
        this.footFields[0].value = this.totalWinnings;
        this.total = res.data.total;
        this.paidOut = res.data.paidOut;

        for(const tId in transactions) {
          transactions[tId].forEach((bet, i) => {
            console.log('bet', bet);
            this.transactions.push(bet);
          })
        }
      } else {
        const message = res.message;
        this.$bvToast.toast(message, {
            title: 'Failed',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000
        })
      }
    },
    () => this.$bvToast.toast('Scan Ticket failed! Please try again', {
        title: 'Failed',
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000
    }));

  },
  methods: {
    handleBackHome() {
      this.$router.push('/ticket');
    },
    handlePayout() {
      accountService.payout(this.totalWinnings, this.ref).then((res) => {
        if (res.status === 'success') {
          this.paidOut = true;
          this.$bvToast.toast("Payout Success!", {
            title: 'Successful',
            variant: 'success',
            solid: true,
            autoHideDelay: 5000
          });
        } else {
          const message = res.message;
          this.$bvToast.toast(message, {
            title: 'Failed',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000
          })
        }
      },
      () => this.$bvToast.toast('Scan Ticket failed! Please try again', {
        title: 'Failed',
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000
      }));
    }
  }
}
</script>
